import { jwtDecode } from 'jwt-decode';
import { getUserRoutesFromStorage, hasGrantedRoutes, normalizeFirstPagePath } from './routePrivilegeMap';

export function resolvePostLoginPath(token: string): string {
  try {
    if (!hasGrantedRoutes(getUserRoutesFromStorage())) {
      return '/portal/no-access';
    }

    const firstPage = normalizeFirstPagePath(localStorage.getItem('first_page') || '');
    if (firstPage) {
      return firstPage;
    }

    const decoded = jwtDecode<{ isadmin: boolean }>(token);

    if (decoded.isadmin.toString() == "false") {
      return '/chat';
    }

    return '/portal/home';
  } catch (error) {
    console.error('Invalid token:', error);
    return '/login';
  }
}

export function redirectBasedOnRole(token: string): void {
  window.location.href = resolvePostLoginPath(token);
}



export interface DecodedUser {
  name: string;
  useremail: string;
  isadmin: boolean;
  sub:string;
}

export function getUserInfo(token: string): DecodedUser | null {
  try {
    const decoded = jwtDecode<DecodedUser>(token);
    return decoded;
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
}